import Info from "@/models/Info";

class OfflineInfoService {
  constructor() {
    this.storageKey = "offlineInfos";
  }

  readMap() {
    if (typeof window === "undefined") {
      return {};
    }
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) {
      return {};
    }
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  writeMap(map) {
    if (typeof window === "undefined") {
      return;
    }
    localStorage.setItem(this.storageKey, JSON.stringify(map));
  }

  list() {
    const map = this.readMap();
    return Object.values(map).map((entry) => new Info(entry.info));
  }

  listByTypes(types = []) {
    if (!types || types.length === 0) {
      return this.list();
    }
    const wanted = types.map((t) => Number(t));
    return this.list().filter((info) => wanted.includes(Number(info.info_type)));
  }

  getRawById(id) {
    const map = this.readMap();
    const entry = map[id];
    return entry ? entry.info : null;
  }

  isOffline(id) {
    const map = this.readMap();
    return Boolean(map[id]);
  }

  setOffline(info) {
    if (!info || !info.id) {
      return;
    }
    const map = this.readMap();
    map[info.id] = {
      info: info.copy ? info.copy() : info,
      updatedAt: Date.now()
    };
    this.writeMap(map);
  }

  removeOffline(id) {
    const map = this.readMap();
    if (map[id]) {
      delete map[id];
      this.writeMap(map);
    }
  }

  updateFromList(infos = []) {
    if (!infos.length) {
      return;
    }
    const map = this.readMap();
    let changed = false;

    infos.forEach((info) => {
      if (info && info.id && map[info.id]) {
        map[info.id] = {
          info: info.copy ? info.copy() : info,
          updatedAt: Date.now()
        };
        changed = true;
      }
    });

    if (changed) {
      this.writeMap(map);
    }
  }
}

export default new OfflineInfoService();
